import { SVGProps, Ref, forwardRef } from 'react';

export const AdjustmentsFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M5.332 2c-1.646 0-2.388.903-2.6 1.966H.5v1.4h2.232c.212 1.063.954 1.966 2.6 1.966s2.389-.903 2.6-1.966H15.5v-1.4H7.932C7.72 2.903 6.978 2 5.332 2"
                fill="currentColor"
            />
            <path
                d="M13.264 10.63c-.211-1.062-.954-1.965-2.6-1.965s-2.389.903-2.6 1.966H.5v1.4h7.564c.212 1.063.954 1.966 2.6 1.966s2.388-.903 2.6-1.966H15.5v-1.4z"
                fill="currentColor"
            />
        </g>
    </svg>
));
AdjustmentsFilledSize16Glyph.displayName = 'AdjustmentsFilledSize16Glyph';
